import AppDispatcher from '../../../flux/dispatcher/dispatcher';
import Constant from '../constant/Constant';
import LogoutConstant from '../../MainFrame/constants/Constants';
import restClient from '../../MainFrame/action/APIClient';

var CreateCustomNavigationAction = function () {

}


CreateCustomNavigationAction.prototype = {

    addNav: function (data) {

        restClient.addNav(data, function (error, response) {
            if (error) {
                if (error.status === 401) {
                    AppDispatcher.dispatch({
                        actionType: LogoutConstant.UNAUTHORIZED_EXCEPTION,
                        data: error
                    });
                }
                else {
                    AppDispatcher.dispatch({
                        actionType: Constant.ADD_CUSTOM_NAV,
                        data: error
                    });
                }
            } else {
                response['status'] = 200;
                AppDispatcher.dispatch({
                    actionType: Constant.ADD_CUSTOM_NAV,
                    data: response
                });
            }
        })
    }
}

export default new CreateCustomNavigationAction();